import { useAlert } from 'hooks';
import { acceptPdfAndImageFileTypes } from 'config';
import { useCategoriesQuery } from 'store/api/accounting';
import { handleFormSubmitWithFiles } from 'utils/helpers';
import {
  Row,
  Col,
  SelectField,
  PaymentsForm,
  DropZoneContent,
  FileDropzoneField,
} from 'components';

import { FormProps, FormValues } from './types';
import { getInitialValues, getValidationSchema } from './config';

export const PaymentReimbursementForm = ({
  data,
  isEdit,
  onSubmit,
  isDialog,
  children,
  employeeId,
  isCompanyOwner,
  ...props
}: FormProps) => {
  const { handleError } = useAlert();

  const { isFetching, data: categories } = useCategoriesQuery();

  const categoryOptions = categories?.map(({ id, name }) => ({
    label: name,
    value: id?.toString(),
  }));

  return (
    <PaymentsForm<FormValues>
      {...props}
      isEdit={isEdit}
      isDialog={isDialog}
      title="reimbursement"
      initialValues={getInitialValues(data, employeeId)}
      validationSchema={getValidationSchema(isCompanyOwner)}
      onSubmit={handleFormSubmitWithFiles({
        data,
        onSubmit,
        handleError,
        files: [
          {
            formFieldName: 'receipt',
            dataFieldName: 'receiptUrl',
            requestFieldName: 'receiptUrl',
          },
        ],
      })}
    >
      {({ values }) => (
        <>
          {children}
          <Row>
            <Col col={isDialog ? undefined : 4}>
              <SelectField
                onlyValue
                name="categoryId"
                label="Select category"
                isDisabled={isFetching}
                options={categoryOptions}
                placeholder="Select category"
              />
            </Col>
          </Row>
          <Row>
            <Col col={isDialog ? undefined : 4}>
              <FileDropzoneField
                errorMessage
                name="receipt"
                label="Upload receipt"
                accept={acceptPdfAndImageFileTypes}
              >
                <DropZoneContent file={values?.receipt} />
              </FileDropzoneField>
            </Col>
          </Row>
        </>
      )}
    </PaymentsForm>
  );
};
